import React from 'react'
import { Text } from './style'

export default ({ value }) => (
    <Text>{value}</Text>
)
